import { useShoppingCart } from '@/src/context/shopping-cart/shopping-cart-context'
import "@/src/extensions/number"
import Coupon from '@/src/interfaces/benefits/coupon'

interface ValidationProps {
    isValid: boolean
    message?: string
}

export default function useCoupon() {
    const { totalItemsPrice, cashbackDiscountPrice } = useShoppingCart()

    const validate = (coupon: Coupon.Response): ValidationProps => {
        let validation: ValidationProps = {
            isValid: false,
            message: 'Cupom inválido para uso.'
        }

        if (cashbackDiscountPrice > 0) {
            validation.message = 'Não é possível utilizar cupom com um cashback aplicado.'
            return validation
        }

        if (!coupon.enabled) {
            validation.message = 'Este cupom não está disponível.'
            return validation
        }

        if (coupon.discountType === 'Valor' && totalItemsPrice < coupon.value) {
            validation.message = 'O valor dos itens deve ser maior que o valor do desconto.'
            return validation
        }

        if (totalItemsPrice < coupon.minimumOrderPrice) {
            validation.message = 'O valor dos itens não atingiu a quantidade mínima do cupom.'
            return validation
        }

        const currentDate = new Date()

        if (currentDate < new Date(coupon.startsAt) || currentDate > new Date(coupon.endsAt)) {
            validation.message = 'Este cupom está fora do período de validade.'
            return validation
        }

        if (coupon.schedules.length > 0) {
            const couponForToday = coupon.schedules.find(s => s.dayOfWeek === currentDate.getDay());

            if (couponForToday) {
                const currentTime = currentDate.toTimeString().split(" ")[0];

                if (currentTime < couponForToday.startTime || currentTime > couponForToday.endTime) {
                    validation.message = 'Cupom inválido para este horário.'
                    return validation
                }
            }
            else {
                validation.message = 'Cupom inválido para este dia.'
                return validation
            }
        }

        return {
            isValid: true
        }
    }

    return { validate }
}
